import * as React from "react";

import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

import { Card, List } from "semantic-ui-react";

import { PartiallyMatchedEmployeeDetailModel } from "../model";

import { Link } from "redux-little-router";

interface PartiallyMatchedFormDetailsProps {
    formDetails: PartiallyMatchedEmployeeDetailModel;
    moreRoute?: string;
    title?: string;
    showAdditionalMatchDetails?: boolean;
}

export const PartiallyMatchedFormDetails: React.FunctionComponent<PartiallyMatchedFormDetailsProps> = (props: PartiallyMatchedFormDetailsProps) => {
    const partialMatchImprovementsEnabled = getFeatureToggles()[FeatureToggleNames.PartialMatchImprovements];

    return (
        <Card>
            <Card.Content>
                {props.title &&
                    <Card.Header className="partial-matches-header">
                        {props.title} Form Details
                    </Card.Header>
                }
                <List>
                    <List.Item>
                        <List.Header>
                            First Name
                        </List.Header>
                        {props.formDetails.firstName}&nbsp;
                    </List.Item>
                    <List.Item>
                        <List.Header>
                            Last Name
                        </List.Header>
                        {props.formDetails.lastName}&nbsp;
                    </List.Item>
                    <List.Item>
                        <List.Header>
                            Email Address
                        </List.Header>
                        {props.formDetails.emailAddress}&nbsp;
                    </List.Item>
                    <List.Item>
                        <List.Header>
                            Date of Birth
                        </List.Header>
                        {props.formDetails.dateOfBirth && props.formDetails.dateOfBirth.format("DD/MM/YYYY")}&nbsp;
                    </List.Item>
                    {partialMatchImprovementsEnabled &&
                        <List.Item>
                            <List.Header>
                                Organisation Structure One
                            </List.Header>
                            {props.formDetails.orgStructureOneName}&nbsp;
                        </List.Item>
                    }
                    {props.showAdditionalMatchDetails &&
                        <>
                            <List.Item>
                                <List.Header>
                                    Mobile Telephone
                                </List.Header>
                                {props.formDetails.mobilePhoneNumber}&nbsp;
                            </List.Item>
                            <List.Item>
                                <List.Header>
                                    Job Role
                                </List.Header>
                                {props.formDetails.jobTitle}&nbsp;
                            </List.Item>
                        </>
                    }
                    <List.Item>
                        <List.Header>
                            Employee Unique ID
                        </List.Header>
                        {props.formDetails.employeeUniqueId}&nbsp;
                    </List.Item>
                    <List.Item>
                        <List.Header>
                            Postcode
                        </List.Header>
                        {props.formDetails.postcode}&nbsp;
                    </List.Item>
                    <List.Item>
                        <List.Header>
                            Customer
                        </List.Header>
                        {props.formDetails.customerName}&nbsp;
                    </List.Item>
                    <List.Item>
                        <List.Header>
                            Termination Date
                        </List.Header>
                        {props.formDetails.terminationDate}&nbsp;
                    </List.Item>
                    {props.moreRoute &&
                        <List.Item>
                            <Link
                                target="_blank"
                                // eslint-disable-next-line max-len
                                href={`/${props.moreRoute}/${props.formDetails.customerId}/${props.formDetails.id}`}
                            >
                                More...
                            </Link>
                        </List.Item>
                    }
                </List>
            </Card.Content>
        </Card>
    );
};
